type TiptapNode = { type?: string; attrs?: Record<string, unknown>; content?: TiptapNode[] };

const collectIds = (node: TiptapNode | undefined, seen: Set<string>, ids: string[]): void => {
  if (!node || typeof node !== "object") return;
  if (node.type === "image" && typeof node.attrs?.uploadId === "string") {
    const id = node.attrs.uploadId;
    if (!seen.has(id)) {
      seen.add(id);
      ids.push(id);
    }
  }
  node.content?.forEach((child) => collectIds(child, seen, ids));
};

export const extractImageUploadIds = (node: TiptapNode | undefined): string[] => {
  if (!node || typeof node !== "object") return [];
  const seen = new Set<string>();
  const ids: string[] = [];
  collectIds(node, seen, ids);
  return ids;
};
